import { RegisterModule } from '@/typings/common'
import {
  MunMeh as Data,
  MunMehCollection as Collection,
} from '@/typings/api/MunMeh'
import { MunMehApi as Api } from '@/api/resources'

import { registerModule as vuexRegisterModule } from 'vuex-smart-module'
import { Builder } from '@/store/createCrudModule'
import { PublicationMunMehAdapter as Adapter } from './PublicationMunMehAdapter'
import { MODULE_NAME } from '../utils'


const useOptions = () => ({
  adapter: new Adapter(),
  idName: 'id' as const,
})

const storeModule = Builder<Data, Collection, Api>(useOptions)
export { storeModule as PublicationMunMehStoreModule }

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
